import { Pipe, type PipeTransform } from '@angular/core';
import { Timestamp } from '@angular/fire/firestore';
import { formatDistanceToNow } from 'date-fns';

@Pipe({
  name: 'dateToNow',
  standalone: true
})
export class DateToNowPipe implements PipeTransform {
  transform(value: Date | Timestamp): string {
    if (value instanceof Timestamp) {
      value = value.toDate();
    }
    return formatDistanceToNow(value, { addSuffix: true });
  }
}
